import React from 'react'
import { Link } from 'react-router-dom'
import { Query } from 'react-apollo'
import moment from 'moment'

import clienti from 'graphql/queries/clienti'

// material-ui components
import withStyles from 'material-ui/styles/withStyles'
import Table from 'material-ui/Table'
import TableHead from 'material-ui/Table/TableHead'
import TableCell from 'material-ui/Table/TableCell'
import TableBody from 'material-ui/Table/TableBody'
import TableRow from 'material-ui/Table/TableRow'

// material-ui-icons
import PhoneMissed from 'material-ui-icons/PhoneMissed'
import ThumbUp from 'material-ui-icons/ThumbUp'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import IconCard from 'components/Cards/IconCard.jsx'
import {
  PortalFilter,
  PortalIndicators,
  getPortalInterestFromFilter,
  getPortalsFromInterests,
  getStoredPortalFilter,
} from 'components/Portal/Portal.jsx'

import dashboardStyle from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle.jsx'

const TableClienti = (props) => {
  const { classes, portalFilter } = props
  const where = {
    daRicontattare: true,
    telNonRisposte_gt: 0,
  }
  const portalInterest = getPortalInterestFromFilter(portalFilter)

  if (portalInterest) where.interessi_any = { nome: portalInterest }

  return (
    <Query
      query={clienti}
      variables={{
        limit: 50,
        offset: 0,
        where,
        orderBy: ['telNonRisposte_DESC', 'dataUltimaRichiesta_DESC'],
      }}
      fetchPolicy="cache-and-network"
    >
      {({ loading, error, data }) => {
        if (loading) return <p>Loading...</p>
        if (error) return <p>Error :(</p>

        if (data.clienti.totalCount === 0 && portalInterest) {
          return (
            <div style={{ padding: '30px 15px', textAlign: 'center' }}>
              <h3>Nessun cliente trovato</h3>
              <h4>Non ci sono clienti senza risposta per il portale selezionato</h4>
            </div>
          )
        }

        return data.clienti.totalCount > 0 ? (
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeadCell}>Portale</TableCell>
                <TableCell className={classes.tableHeadCell}>Nome</TableCell>
                <TableCell className={classes.tableHeadCell}>Comune</TableCell>
                <TableCell className={classes.tableHeadCell}>Data ultimo contatto</TableCell>
                <TableCell className={classes.tableHeadCell}>Data ultima richiesta</TableCell>
                <TableCell className={classes.tableHeadCell}>Email</TableCell>
                <TableCell className={classes.tableHeadCell}>Telefono</TableCell>
                <TableCell className={classes.tableHeadCell}>Agente</TableCell>
                <TableCell className={classes.tableHeadCell}>N° tel non risp.</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.clienti.nodes.map((cliente) => (
                <TableRow key={cliente.id}>
                  <TableCell className={classes.tableCell}>
                    <PortalIndicators portals={getPortalsFromInterests(cliente.interessi)} />
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: cliente.daRicontattare ? 'bold' : 'normal' }}
                  >
                    <Link
                      to={`/clienti/${cliente.id}`}
                      style={{ color: cliente.nuovoClienteFlag ? '#2ab32a' : 'auto' }}
                    >
                      {cliente.nome ? cliente.nome : <i>Senza nome</i>}
                    </Link>
                  </TableCell>
                  <TableCell className={classes.tableCell}>{cliente.comune}</TableCell>
                  <TableCell className={classes.tableCell}>
                    {cliente.dataUltimoContatto
                      ? moment(cliente.dataUltimoContatto).format('DD/MM/YYYY HH:mm')
                      : ''}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {cliente.dataUltimaRichiesta
                      ? moment(cliente.dataUltimaRichiesta).format('DD/MM/YYYY')
                      : 'Nessuna richiesta'}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <a href={`mailto:${cliente.email}`}>{cliente.email}</a>
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <a href={`tel:${cliente.telefono}`}>{cliente.telefono}</a>
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {cliente.agente ? cliente.agente.nome : <i>Senza agente</i>}
                  </TableCell>
                  <TableCell className={classes.tableCell}>{cliente.telNonRisposte}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="success-message">
            <ThumbUp />
            <h3>Congratulazioni!</h3>
            <h4>Hai ricontattato tutti i tuoi clienti</h4>
          </div>
        )
      }}
    </Query>
  )
}

class ClientiNonRisposto extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      portalFilter: getStoredPortalFilter(),
    }
  }

  handleChangePortalFilter = (portalFilter) => {
    this.setState({ portalFilter })
  }

  render() {
    const { classes } = this.props

    return (
      <GridContainer>
        <ItemGrid xs={12}>
          <IconCard
            icon={PhoneMissed}
            iconColor="blue"
            title="Clienti che non hanno risposto"
            filter={
              <PortalFilter
                value={this.state.portalFilter}
                onChange={this.handleChangePortalFilter}
                style={{ width: 210, maxWidth: '100%', margin: '0 0 15px auto' }}
              />
            }
            content={
              <div>
                <TableClienti classes={classes} portalFilter={this.state.portalFilter} />
              </div>
            }
          />
        </ItemGrid>
      </GridContainer>
    )
  }
}

export default withStyles(dashboardStyle)(ClientiNonRisposto)



// WEBPACK FOOTER //
// ./src/views/App/Clienti/ClientiNonRisposto.jsx